import React, { useState, useRef, useEffect } from 'react';

export const Tooltip = ({ content, children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef(null);
  const containerRef = useRef(null);
  const [positionAbove, setPositionAbove] = useState(false);

  useEffect(() => {
    if (!isVisible || !tooltipRef.current || !containerRef.current) return;

    const tooltipRect = tooltipRef.current.getBoundingClientRect();
    const containerRect = containerRef.current.getBoundingClientRect();

    const isBottomOverflow = tooltipRect.bottom > window.innerHeight;

    setPositionAbove(isBottomOverflow);
  }, [isVisible]);

  return (
    <div className="relative inline-block" ref={containerRef}>
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </div>
      {isVisible && (
        <div
          ref={tooltipRef}
          className={`absolute z-50 max-w-xs w-max p-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-lg break-words whitespace-normal overflow-hidden 
          ${positionAbove ? 'bottom-full mb-1' : 'top-full mt-1'}`}
        >
          {content}
        </div>
      )}
    </div>
  );
};
